import {createListFromObject} from "../../components/common/commonUtilities";
export const PolicyResponseCopyStrategyType =
    {
        NotCopyResponse: "NotCopyResponse",
        CopyButNotMarkAsApproved: "CopyButNotMarkAsApproved",
        CopyAndMarkAsApproved: "CopyAndMarkAsApproved"
    };
export const PolicyResponseCopyStrategyList = createListFromObject(PolicyResponseCopyStrategyType);

export const DefaultPolicyResponseCopyStrategy = PolicyResponseCopyStrategyType.CopyAndMarkAsApproved;